import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Parts} from "components/index";
import moment from "moment-timezone";

export default class MainCalendar extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.timeout = null;
		this.state.search = "";
		this.state.filterFilledHoles = false;
		this.state.filterHoles = false;
		this.state.region = 0
		this.state.regions = [];
		this.state.calResources = [props.currentFE];
		this.state.user = 0;
		this.state.filterDate = new Date();
		this.handleSearch = this.handleSearch.bind(this);
		this.handleDate = this.handleDate.bind(this);
		this.state.limit = 50;
		this.state.currentCalendar = '';
		this.state.formattedFilterDate = new Date().getDate();
		this.state.dateChanged = false;
		this.state.mapsUrls = 'https://www.google.com/maps/dir';
	}

	//initial load
	async componentDidMount() {
		await this.getCalTickets();
		await this.getCalResources();
	}

	// componentDidUpdate(prevProps, prevState, snapshot) {
	// 	if (prevState.calEvent !== this.state.calEvent || this.state.dateChanged)
	// 	{
	// 		this.formatMapsUrl(this.state.calEvent)
	// 	}
	// }
	//
	// formatMapsUrl = (data) => {
	// 	let url = "https://www.google.com/maps/dir"
	// 	data?.forEach((event) => {
	// 		if (event.customer_address !== undefined && this.state.formattedFilterDate === new Date(event.start).getDate()) {
	// 			if (url === "https://www.google.com/maps/dir" && event.users.street_1.length > 1) {
	// 				let feAddress = ("/" + event.users.street_1 + "+" + event.users.city + "+" + event.users.state + "+" + event.users.zip);
	// 				url += feAddress.replaceAll("#", "%23");
	// 			}
	// 			let formattedAddress = "/" + event.customer_address.replaceAll(" ", "+").replaceAll("#", "%23")
	// 			url += formattedAddress;
	// 		}
	// 	})
	// 	this.setState({mapsUrls: url})
	// 	this.state.dateChanged = false;
	// }

	getCalResources = async () => {
		this.setState({loadingResources: true})
		let model = new API.BuildClass(Types.Calendar_Resources._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		model.limit = 50;
		let week = moment(this.state.filterDate).add(1, 'day').isoWeek().toString();
		let prevweek = moment(this.state.filterDate).isoWeek().toString();
		if (week.length === 1) {
			week = ('0' + week);
		}

		if (prevweek.length === 1) {
			prevweek = ('0' + prevweek);
		}
		let year = moment(this.state.filterDate).year().toString();

		model.filter = {
			'filterDate': year + week,
			'prevDate': year + prevweek,
			'date': moment(this.state.filterDate).tz('America/Phoenix').format('YYYY-MM-DD'),
			'filterUsers': [this.props.field_engineer],
			'forEngineer': true
		}
		this.calResources = await model.submit(null, this.read);
		this.calResources = this.calResources.items;
		this.state.calResources = this.calResources
		this.state.key = Math.random()

		if (this.state.mapsUrlsData && this.state.mapsUrlsData[0]) {
			const urlsDate = moment(this.state.filterDate).format('YYYY-MM-DD');
			if (this.state.mapsUrlsData[0].mapsUrls[urlsDate]) {
				this.setState({mapsUrls: this.state.mapsUrlsData[0].mapsUrls[urlsDate]})
			} else {
				this.setState({mapsUrls: 'https://www.google.com/maps/dir'})
			}
		}

		this.setState({loadingResources: false})
		return this.state.calResources;
	}

	getCalTickets = async () => {
		let model = new API.BuildClass(Types.Calendar._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		model.limit = 100;
		model.filter = {
			'filterDate': this.state.filterDate,
			'filterUsers': [this.props.field_engineer],
		}
		try {
			model.search = this.state.search
			this.calEvent = await model.submit(null, this.read);
			this.setState({mapsUrlsData: this.calEvent.mapsUrls})
			this.calEvent = Object.keys(this.calEvent).map((key) => this.calEvent[key]);
			this.calEvent = this.calEvent[3];
			this.setState({
				calEvent: this.calEvent
			});
		} catch (error) {
		}
		this.props.passDate();
		return this.state.calEvent;
	}

	handleSearch(event) {
		event.persist()
		const search = event.target.value
		if (this.state.timeout) {
			// User typed another character in less than 500ms,
			// cancel the pending request so the main thread doesn't block while they type.
			// if (typeof this.call.cancel === 'function') this.call.cancel();
			clearTimeout(this.state.timeout);
		}
		this.state.timeout = setTimeout(() => {
			if (this.model) {
				this.state.search = search
				this.getCalTickets()
			}

		}, 500);

	}

	handleDate(date) {
		this.props.passDate(date);
		this.state.filterDate = date;
		this.state.formattedFilterDate = new Date(date).getDate();
		this.setState({dateChanged: true})
	}

	render() {
		const {loading} = this.state
		return (
			<div className={"box-body"}>
				<Parts.EngineerCalendar
					parentProps={this.props}
					ticket={this.props.id}
					events={{...this.state.calEvent}}
					//lowercase default: Calendar.Views ('month'|'week'|'work_week'|'day'|'agenda')
					defaultView="day"
					reloadSelf={this.state.refresh}
					updateData={async () => {
						await this.getCalTickets()
						await this.getCalResources();
					}}
					updateCalResources={async () => {
						await this.getCalResources()
					}}
					handleDate={this.handleDate}
					history={this.props.history}
					currentFE={this.props.currentFE}
					mapsUrls={this.state.mapsUrls}
					resourceMap={this.state.calResources}
					loadingResources={this.state.loadingResources}
				/>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
